import React from 'react';
import { Button } from '../components/ui/Button';
import { getLink } from '../config/links';
import { TourMockCapture } from '../components/mocks/TourMockCapture';
import { TourMockBrief } from '../components/mocks/TourMockBrief';
import { TourMockReview } from '../components/mocks/TourMockReview';
import { TourMockInbox } from '../components/mocks/TourMockInbox';

export const TourPage: React.FC = () => {
  const signupLink = getLink('signup');
  const loginLink = getLink('login');

  const steps = [
    {
      title: "1. Capture uma nota",
      desc: "Cole texto, um resumo rápido ou até uma transcrição bruta. O formato não importa.",
      component: <TourMockCapture />
    },
    {
      title: "2. Transforme em Brief",
      desc: "A IA estrutura decisões, define donos e extrai riscos automaticamente.",
      component: <TourMockBrief />
    },
    {
      title: "3. Revise e confirme",
      desc: "Você está no controle. Ajuste o que precisar. Ao salvar, vira o registro oficial.",
      component: <TourMockReview />
    },
    {
      title: "4. Execute na Inbox",
      desc: "Suas tarefas e as que você delegou aparecem organizadas por prazo.",
      component: <TourMockInbox />
    }
  ];

  return (
    <div className="min-h-screen bg-background pt-28 pb-20">
      <div className="max-w-3xl mx-auto px-4 text-center mb-16">
        <h1 className="font-display font-bold text-3xl md:text-5xl text-ink mb-6">
          Veja o PERO Brief em 60s
        </h1>
        <p className="text-lg text-muted">
          Um tour rápido do fluxo: Nota → Brief → Inbox.
        </p>
      </div>

      <div className="max-w-5xl mx-auto px-4 relative">
        {/* Connecting Line */}
        <div className="absolute left-8 md:left-1/2 top-0 bottom-0 w-px bg-border -z-10"></div>

        <div className="space-y-24">
          {steps.map((step, index) => (
            <div key={index} className="relative grid md:grid-cols-2 gap-8 md:gap-16 items-center">
              
              {/* Timeline Dot */}
              <div className="absolute left-8 md:left-1/2 w-4 h-4 rounded-full bg-primary border-4 border-white shadow-sm -translate-x-1/2"></div>

              {/* Text Side (Alternating) */}
              <div className={`pl-16 md:pl-0 ${index % 2 === 0 ? 'md:text-right md:pr-12' : 'md:order-2 md:pl-12'}`}>
                <h2 className="font-display font-bold text-2xl text-ink mb-3">{step.title}</h2>
                <p className="text-muted leading-relaxed">{step.desc}</p>
              </div>

              {/* Component Side (Alternating) */}
              <div className={`pl-12 md:pl-0 ${index % 2 === 0 ? 'md:order-2 md:pl-12' : 'md:pr-12'}`}>
                <div className="transform transition-transform duration-500 hover:scale-[1.02]">
                  {step.component}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Final Action */}
      <div className="max-w-2xl mx-auto text-center mt-32 px-4">
        <div className="bg-white p-10 rounded-3xl border border-border shadow-sm">
          <h3 className="font-display font-bold text-2xl text-ink mb-4">Pronto para começar?</h3>
          <p className="text-muted mb-8 text-base">
            E se eu não tiver transcrição? <br/>
            <span className="text-ink font-medium">Sem problema. Nota rápida também funciona.</span>
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button href={signupLink} size="lg" className="w-full sm:w-auto shadow-lg shadow-primary/20">
              Cadastrar
            </Button>
            <Button href={loginLink} variant="outline" size="lg" className="w-full sm:w-auto">
              Entrar
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};